import { Agenda, Event } from "@/models/agenda.model";
import { AgendaMapper } from "./agenda.mapper";
import moment from "moment";

export class AgendaUtils {
  constructor(private _agendaMapper = new AgendaMapper()) {}

  formatEvents(events: Array<Agenda>): Array<Event> {
    if (events?.length === 0 || !events) return [];
    return events?.map((res) => this._agendaMapper.toDomain(res));
  }
  formatDate(fullDate: string): string {
    return moment(fullDate).locale(navigator.language).format("LLL");
  }
  isValidUrl(url: string): boolean {
    const regex = /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(\/[\w- .\/?%&=]*)?$/;
    return regex.test(url);
  }
}
